import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import HEADER from './LMS_View/LMS_LAYOUT/Header';

const useAuth = () => {
    let data = JSON.parse(localStorage.getItem('user_data'))
    let user = data && data.vemp_code;
    if (user) {
        try {
            if (user) {
                return user;

            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const ProtectedRoutes = ({ element, allowedRoles, ...rest }) => {
    // console.log("rest ", rest)
    const auth = useAuth()
    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name
    if (!auth || !role) {
        return <Navigate to="/login" />;
    }

    if (allowedRoles && allowedRoles.includes(role)) {
        // Render the protected element with additional props
        return (
            <div>
                <HEADER sidebar={rest.sidebar} setSidebar={rest.setSidebar} />
                <div id='content' className='margntop mb-3 ps-2 pe-2'>
                    {/* {React.cloneElement(element, rest)} */}
                    <Outlet />
                </div>
            </div>
        );
    } else {

        return <Navigate to={role == "Learner" ? '/learner-dashboard' : '/dashboard'} />;
    }
}

export default ProtectedRoutes;
